
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid2,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Colors from "../../assets/styles";
import { useForm } from "react-hook-form";
import AuthServices from "../../apis/AuthServices";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";
import {  useNavigate } from "react-router-dom";

export default function LocomotiveForm() {
 
  const [locomotives, setLocomotives] = useState([]);
  const navigate = useNavigate()

  const {
    
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      imei: "",
      number: "",
    },
  });

  const onSubmit = async (formData) => {
    const obj = {
      LocomotiveNumber: formData?.name,
      MobileNumber: formData?.number,
      imie: formData?.imei,
    };
    try {
      const result = await AuthServices.addLocomotive(obj);
      // console.log(result);
      if (result.IsSuccess == true) {
        setLocomotives([...locomotives,obj]);
        reset()
        SuccessToaster("Locomotives Added Successfully");
      }else{
        ErrorToaster("Something went Wrong")
      }
    } catch (error) {
      ErrorToaster("Something went Wrong");
    }
  };

  // console.log(locomotives)

  const handleSave = () => {
    navigate("/locomotive-list")
  };

  return (
    <Box sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          
          borderColor: "divider",
          mb: 1,
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          sx={{
            color: Colors.primary,
            fontWeight: 500,
            letterSpacing: "1px",
          }}
        >
          ADD LOCOMOTIVE
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          LOCOMOTIVE / ADD LOCOMOTIVE
        </Typography>
      </Box>

      <Card sx={{ mb: 4 ,borderRadius:"12px"}}>
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: 1,
            color: Colors.primary,
            
            borderColor: "divider",
          }}
        >
          <Typography variant="h6">LOCOMOTIVE DETAILS</Typography>
        </Box>
        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container spacing={3}>
              {/* Locomotive Name */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Locomotive Name
                </Typography>

                <TextField
                  fullWidth
                  placeholder="Enter Locomotive Name"
                  
                  {...register("name", {
                    required: "Locomotive name is required",
                  })}
                  error={!!errors.name}
                  helperText={errors.name?.message}
                />
              </Grid2>

              {/* IMEI */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  IMEI #
                </Typography>

                <TextField
                  fullWidth
                  placeholder="Enter IMEI number"
                  
                  {...register("imei", { required: "IMEI is required" })}
                  error={!!errors.imei}
                  helperText={errors.imei?.message}
                />
              </Grid2>

              {/* Mobile */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Mobile #
                </Typography>

                <TextField
                  fullWidth
                  placeholder="Enter Mobile number"
                  
                  {...register("number", { required: "Number is required" })}
                  error={!!errors.number}
                  helperText={errors.number?.message}
                />
              </Grid2>

              {/* Add Button */}
              <Grid2
                size={{ xs: 12, md: 12 }}
                sx={{ display: "flex", alignItems: "flex-end" }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    bgcolor: "#133e02",
                    "&:hover": {
                      bgcolor: "green.800",
                    },
                  }}
                >
                  <AddIcon />
                </Button>
              </Grid2>
            </Grid2>
          </form>
        </CardContent>
      </Card>

      <Card  sx={{borderRadius:"12px"}}> 
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: 1,
            borderColor: "divider",
            color: Colors.primary,
          }}
        >
          <Typography variant="h6">ADDED LOCOMOTIVE LIST</Typography>
        </Box>
        <CardContent>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "#133e02" }}>
                  <TableCell sx={{ color: "white" }}>#</TableCell>
                  <TableCell sx={{ color: "white" }}>Locomotive Name</TableCell>
                  <TableCell sx={{ color: "white" }}>IMEI #</TableCell>
                  <TableCell sx={{ color: "white" }}>Mobile #</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {locomotives.map((loco, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{loco.LocomotiveNumber}</TableCell>
                    <TableCell>{loco.imie}</TableCell>
                    <TableCell>{loco.MobileNumber}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {locomotives.length > 0 && (
            <Button
              variant="contained"
              sx={{
                mt: 2,
                bgcolor: "rgb(19 62 2)",
                "&:hover": {
                  bgcolor: "rgb(19 62 2)",
                },
              }}
              onClick={handleSave}
            >
              Save
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
